export class DashboardNavbarHtml {
  dashboardnavbarskin() {
    return `
      <div class="topbar">
        <div class="topbar-header">
          <h1 class="Page heading">---</h1>
          <p>Evaluate and monitor your power energy parameters</p>
        </div>

        <div class="d-flex justify-space-between min-w-500 overflow-hidden overflow-x-scroll gap-15">
          <!-- INVERTERS -->
          <div data-block="inverter" class="data-block section inverters max-w-200">
            <h3 class="text-left">INVERTERS</h3>
            <div class="data-row w-100">
              <span class="d-flex justify-space-between w-100">Active Power</span>
              <div class="inner-data-row">
                <span class="min-w-50 text-right bg-subcontainer" data-register="PV Power">0</span>
                <span>MW</span>
              </div>
            </div>
            <div class="data-row w-100">
              <span class="d-flex justify-space-between w-100">Reactive Power</span>
              <div class="inner-data-row">
                <span class="min-w-50 text-right bg-subcontainer" data-register="PV Reactive Power">0</span>
                <span>kVAr</span>
              </div>
            </div>
            <div class="data-row w-100">
              <span class="d-flex justify-space-between w-100">Total Energy</span>
              <div class="inner-data-row">
                <span class="min-w-50 text-right bg-subcontainer" data-register="PV Total Energy">0</span>
                <span>MWh</span>
              </div>
            </div>
          </div>

          <!-- BESS -->
          <div data-block="bess" class="data-block section bess max-w-200">
            <h3>BESS</h3>
            <div class="data-row w-100">
              <span class="d-flex justify-space-between w-100">Charge / Discharge</span>
              <div class="inner-data-row">
                <span class="min-w-50 text-right bg-subcontainer" data-register="BESS Power">0</span>
                <span>kW</span>
              </div>
            </div>
            <div class="data-row w-100">
              <span class="d-flex justify-space-between w-100">SOC</span>
              <div class="inner-data-row">
                <span class="min-w-50 text-right bg-subcontainer" data-register="BESS SOC">0</span>
                <span>%</span>
              </div>
            </div>
            <div class="data-row w-100">
              <span class="d-flex justify-space-between w-100">Total Energy</span>
              <div class="inner-data-row">
                <span class="min-w-50 text-right bg-subcontainer" data-register="BESS Total Energy">0</span>
                <span>MWh</span>
              </div>
            </div>
          </div>

          <!-- GENERATOR -->
          <div data-block="generator" class="data-block section generator max-w-200">
            <h3>GENERATOR</h3>
            <div class="data-row w-100">
              <span class="d-flex justify-space-between w-100">Active Power</span>
              <div class="inner-data-row">
                <span class="min-w-50 text-right bg-subcontainer" data-register="Gen Power">0</span>
                <span>kW</span>
                </div>
            </div>
            <div class="data-row w-100">
              <span class="d-flex justify-space-between w-100">Fuel Level</span>
              <div class="inner-data-row">
                <span class="min-w-50 text-right bg-subcontainer" data-register="Gen Fuel Level">0</span>
                <span>%</span>
              </div>
            </div>
            <div class="data-row w-100">
              <span class="d-flex justify-space-between w-100">Status</span>
              <div class="inner-data-row">
                <span class="min-w-50 text-right bg-subcontainer" data-register="Gen Status">0</span>
                <span></span>
              </div>
            </div>
          </div>

          <!-- METERS -->
          <div data-block="met" class="data-block section meters max-w-200">
            <h3>METERS</h3>
            <div class="data-row w-100">
              <span class="d-flex justify-space-between w-100">Active Power</span>
              <div class="inner-data-row">
                <span class="min-w-50 text-right bg-subcontainer" data-register="MET Active Power">0</span>
                <span>kW</span>
              </div>
            </div>
            <div class="data-row w-100">
              <span class="d-flex justify-space-between w-100">Reactive Power</span>
              <div class="inner-data-row">
                <span class="min-w-50 text-right bg-subcontainer" data-register="MET Reactive Power">0</span>
                <span>kVAr</span>
              </div>
            </div>
            <div class="data-row w-100">
              <span class="d-flex justify-space-between w-100">Total Energy</span>
              <div class="inner-data-row">
                <span class="min-w-50 text-right bg-subcontainer" data-register="MET Total Energy">0</span>
                <span>MWh</span>
              </div>
            </div>
          </div>

          <!-- MET STATION -->
          <div data-block="met_station" class="data-block section met-station max-w-200">
            <h3>MET STATION</h3>
            <div class="data-row w-100">
              <span class="d-flex justify-space-between w-100">Plant Irradiance</span>
              <div class="inner-data-row">
                <span class="min-w-50 text-right bg-subcontainer" data-register="Plant Irradiance">0</span>
                <span>W/m²</span>
              </div>
            </div>
            <div class="data-row w-100">
              <span class="d-flex justify-space-between w-100">Ambient Temp.</span>
              <div class="inner-data-row">
                <span class="min-w-50 text-right bg-subcontainer" data-register="Ambient Temp">0</span>
                <span>°C</span>
              </div>
            </div>
            <div class="data-row w-100">
              <span class="d-flex justify-space-between w-100">Wind Speed</span>
              <div class="inner-data-row">
                <span class="min-w-50 text-right bg-subcontainer" data-register="Wind Speed">0</span>
                <span>m/s</span>
              </div>
            </div>
          </div>

          <!-- AVAILABLE POWER -->
          <div class="section available-power max-w-200">
            <h3>AVAILABLE POWER</h3>
            <div class="data-row w-100">
              <span class="d-flex justify-space-between w-100">Fail Modules</span>
              <div class="inner-data-row">
                <span class="min-w-50 text-right bg-subcontainer" data-register="Fail Modules">0</span>
                <span></span>
              </div>
            </div>
            <div class="data-row w-100">
              <span class="d-flex justify-space-between w-100">Grid Power</span>
              <div class="inner-data-row">
                <span class="min-w-50 text-right bg-subcontainer" data-register="Grid Power">0</span>
                <span>MW</span>
              </div>
            </div>
            <div class="data-row w-100">
              <span class="d-flex justify-space-between w-100">Availability</span>
              <div class="inner-data-row">
                <span class="min-w-50 text-right bg-subcontainer" data-register="Avail Power P">0</span>
                <span>%</span>
              </div>
            </div>
          </div>

          <!-- GENERAL -->
          <div class="section general min-w-200 w-100">
            <h3>GENERAL</h3>
            <div class="data-row w-100"><span>Date</span><span class="max-w-100 text-right bg-subcontainer w-100" id="date">-----</span></div>
            <div class="data-row w-100"><span>Time</span><span class="max-w-100 text-right bg-subcontainer w-100" id="time">-:-:-</span></div>
            <div class="data-row w-100"><span>Username</span><span class="max-w-100 text-right bg-subcontainer w-100" id="username">---</span></div>
          </div>
        </div>
      </div>
    `;
  }
}